// Attribution: https://github.com/Azure-Samples/ms-identity-javascript-react-tutorial/blob/main/5-AccessControl/1-call-api-roles/SPA/src/components/RouteGuard.jsx
// TODO: setup authorization as per business req's
// Use Azure, ACF, or other API to retrieve roles
// Return specific role names as needed

// MSAL
import { msalInstance } from "index.js";

function useAuthorization() {
	const account = msalInstance.getActiveAccount();


	function getRoles() {

		// get roles from Azure
		let roles = account?.idTokenClaims?.roles || [];

		// send back specific roles names for easier usage
		return {
			roles,
			isAdmin: roles.includes("Admin") || false
		}
	}

	return {
		getRoles
	}
}

export { useAuthorization };